// src/pages/B2B/event-reports/components/TimezoneSelect.tsx
import React, { useMemo, useState } from 'react';

const PINNED: string[] = [
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
];

function allZones(): string[] {
  type IntlWithSupported = typeof Intl & { supportedValuesOf?: (key: string) => string[] };
  const intl = Intl as IntlWithSupported;
  if (typeof intl.supportedValuesOf === 'function') {
    return intl.supportedValuesOf('timeZone');
  }
  return PINNED;
}

export function TimezoneSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (tz: string) => void;
}): React.ReactElement {
  const [search, setSearch] = useState('');

  const zones = useMemo(() => {
    const all = allZones();
    const pinnedSet = new Set(PINNED);
    const rest = all.filter((z) => !pinnedSet.has(z));
    const ordered = [...PINNED, ...rest];
    if (!search) return ordered;
    const q = search.toLowerCase();
    return ordered.filter((z) => z.toLowerCase().includes(q));
  }, [search]);

  return (
    <div className="flex flex-col gap-2">
      <input
        type="text"
        placeholder="Search timezones…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="px-3 py-2 text-sm bg-gray-900 border border-gray-700 rounded-lg text-gray-200 placeholder-gray-500 focus:outline-none focus:border-violet-500"
      />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="px-3 py-2 text-sm bg-gray-900 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:border-violet-500 max-h-60"
      >
        {zones.map((z) => (
          <option key={z} value={z}>
            {z}
          </option>
        ))}
      </select>
    </div>
  );
}

export default TimezoneSelect;
